export default __webpack_public_path__ + "static/media/screen1.d69bce76.png";